<template>

<div class="container-fluid bg-white h-100 w-100">
  <div class="row flex-nowrap" style="min-width: 830px;">

    <!-- Dispositivos -->
    <div class="col-auto border rounded p-1 devices-panel" style="margin:10px; width: 260px; min-width: 260px;">

      <!-- Titulo -->
      <div class="d-flex justify-content-between align-items-center">
        <h4>{{ $t("plane.devices") }}</h4>

        <!-- Botón ayuda -->
        <div style="position: relative;">
          <b-icon
            icon="question-circle-fill"
            style="cursor: pointer; margin-bottom: 5px;"
            @click.stop="showHelp = !showHelp"
          />

          <!-- Popover manual -->
          <div
            v-if="showHelp"
            class="help-popover"
            v-click-outside="() => showHelp = false"
          >
            <div class="help-popover__arrow" />

            <p class="help-popover__title">{{ $t("plane.instructions") }}</p>

            <p class="mb-1">
              <strong>Drag & Drop</strong> — arrastra un dispositivo al plano
            </p>
            <p class="mb-1">
              <strong>Shift + arrastrar</strong> — mover el plano
            </p>
            <p class="mb-1">
              <strong>Rueda del mouse</strong> — zoom
            </p>
            <p class="mb-1">
              <strong>Alt + rueda</strong> — rotar dispositivo
            </p>
            <p class="mb-0">
              <strong>Doble click</strong> — editar nombre del plano
            </p>
          </div>
        </div>
      </div>

      <hr/>

      <!-- Imagen del A-->
      <div class="d-flex justify-content-between align-items-center my-1">
        <img  
          class="img-white" 
          :src="textImage"
          style="width: 20px; max-width: 20px;" 
          alt="Texto"
        />
        <!-- <div
          draggable="true"
          @dragstart="startDragText"
          style="cursor: grab;"
          title="Arrastra para agregar texto al plano"
        >
          <img  
            class="img-white" 
            :src="textImage"
            style="width: 20px; max-width: 20px;" 
            alt="Texto"
          />
        </div> -->

        <b-button variant="secondary" size="sm" @click="savePlanes" :disabled="isSaving">
          <b-spinner v-if="isSaving" small class="mr-1" />
          {{ isSaving ? '...' : $t("actions.save") }}
        </b-button>
      </div>

      <!-- Cargando -->
      <div v-if="isLoading" class="text-center my-3">
        <span class="text-muted">
          <b-spinner small class="mr-1" />
          Cargando...
        </span>
      </div>

      <!-- Lista de los elementos -->
      <template v-if="!isLoading">
        <div class="devices-list">
          <div class="accordion" id="accordion-devices">

            <!-- ── Cámaras ───────────────────────────────────────── -->
            <b-card no-body style="margin: 0px;" v-if="groupedCameras.cameras.length">
              <b-card-header header-tag="div" class="p-0 border rounded">
                <b-button
                  block
                  v-b-toggle="'collapse-cameras'"
                  variant="link"
                  style="padding-top: 10px; padding-bottom: 10px;"
                  class="text-left d-flex justify-content-between align-items-center px-1"
                >
                  <div class="d-flex align-items-center">
                    <feather-icon icon="VideoIcon" size="14" class="mr-1" />
                    <span class="device-name">{{ 'Cámaras' }}</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <b-badge
                      :variant="allDevicesUsed(groupedCameras.cameras) ? 'secondary' : 'primary'"
                      style="margin-right:5px;"
                      v-b-tooltip.hover.top="allDevicesUsed(groupedCameras.cameras) ? 'Todos los dispositivos están en uso' : ''"
                    >
                      {{ groupedCameras.cameras.length }}
                    </b-badge>
                    <!-- Cámaras -->
                    <b-badge
                      v-b-tooltip.hover.top
                      title="Agregar todo"
                      variant="primary"
                      style="margin-right:5px; cursor:pointer;"
                      @click.stop="addAllToPlane(groupedCameras.cameras)"
                    >
                      <feather-icon icon="PlusIcon" size="13" />
                    </b-badge>
                    <feather-icon icon="ChevronDownIcon" size="14" />
                  </div>
                </b-button>
              </b-card-header>
              <b-collapse id="collapse-cameras" accordion="accordion-devices">
                <b-card-body style="background: #f8f9fa; padding: 1px;">
                  <div style="padding: 4px;">
                    <b-form-input
                      v-model="filters.cameras"
                      size="sm"
                      placeholder="Buscar..."
                      @click.stop
                      style="font-size: 12px;"
                    />
                  </div>
                  <div
                  v-for="camera in filteredCameras"
                  :key="camera.camera_proxy_id"
                  class="device-item d-flex justify-content-start align-items-center border rounded"
                  style="margin: 3px; background: white;"
                  :draggable="!usedDeviceIds.has(camera.camera_proxy_id)"
                  :style="usedDeviceIds.has(camera.camera_proxy_id) ? { opacity: 0.4, cursor: 'not-allowed' } : {}"
                  @dragstart="!usedDeviceIds.has(camera.camera_proxy_id) && startDrag(camera)"
                  >
                    <img :src="setImage(camera)" width="18px" />
                    <span class="status-dot" style="flex-shrink: 0;"></span>
                    <span
                      class="device-name"
                      v-b-tooltip.hover
                      :title="camera.name"
                    >
                      {{
                        camera.name
                          ? (camera.name.length > 20
                              ? camera.name.substring(0, 20) + '...'
                              : camera.name)
                          : ''
                      }}
                    </span>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- ── Alarm Bridges ──────────────────────────────────── -->
            <template v-for="bridge in groupedCameras.bridges">

            <!-- Pacom -->
            <b-card
              v-if="bridge.devices && bridge.camera_type === 'alarm_bridge_pacom'"
              :key="`pacom-wrap-${bridge.camera_proxy_id}`"
              no-body
              style="margin: 0px;"
            >
              <b-card-header header-tag="div" class="p-0 border rounded">
                <b-button
                  block
                  v-b-toggle="`collapse-pacom-${bridge.camera_proxy_id}`"
                  variant="link"
                  style="padding-top: 10px; padding-bottom: 10px;"
                  class="text-left d-flex justify-content-between align-items-center px-1"
                >
                  <div class="d-flex align-items-center" style="min-width: 0;">
                    <feather-icon icon="CpuIcon" size="14" class="mr-1" style="flex-shrink: 0;" />
                    <div style="display: flex; flex-direction: column; line-height: 1.2; min-width: 0;">
                      <span
                        class="device-name"
                        style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                        v-b-tooltip.hover.top="bridge.name"
                      >
                        {{ bridge.name }}
                      </span>
                      <span style="font-size: 10px; color: #9e9e9e;">Panel Pacom</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <b-badge
                      :variant="allBridgeDevicesUsed(bridge) ? 'secondary' : 'primary'"
                      style="margin-right:5px;"
                      v-b-tooltip.hover.top="allBridgeDevicesUsed(bridge) ? 'Todos los dispositivos están en uso' : ''"
                    >
                      {{ countBridgeDevices(bridge) }}
                    </b-badge>
                    <b-badge
                      v-b-tooltip.hover.top
                      title="Agregar todo"
                      variant="primary"
                      style="margin-right:5px; cursor:pointer;"
                      @click.stop="addAllToPlane(getBridgeDevices(bridge))"
                    >
                      <feather-icon icon="PlusIcon" size="13" />
                    </b-badge>
                    <feather-icon icon="ChevronDownIcon" size="14" />
                  </div>
                </b-button>
              </b-card-header>
              <b-collapse :id="`collapse-pacom-${bridge.camera_proxy_id}`" accordion="accordion-devices" >
                <b-card-body style="background: #f8f9fa; padding: 5px;">

                  <div style="padding: 4px 0;">
                    <b-form-input
                      :value="getBridgeFilter(bridge.camera_proxy_id)"
                      @input="setBridgeFilter(bridge.camera_proxy_id, $event)"
                      size="sm"
                      placeholder="Buscar..."
                      @click.stop
                      style="font-size: 12px;"
                    />
                  </div>

                  <AlarmBridgePacom
                    :camera="bridge"
                    :setImage="setImage"
                    :usedDeviceIds="usedDeviceIds"
                    :cameraList="cameras"
                    :hideHeader="true"
                    :filter="getBridgeFilter(bridge.camera_proxy_id)"
                    @drag-device="startDrag"
                  />
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- Bosch -->
            <b-card
              v-else-if="bridge.devices && (bridge.camera_type === 'alarm_bridge_bosch')"
              :key="`bosch-wrap-${bridge.camera_proxy_id}`"
              no-body
              style="margin: 0px;"
            >
              <b-card-header header-tag="div" class="p-0 border rounded">
                <b-button
                  block
                  v-b-toggle="`collapse-bosch-${bridge.camera_proxy_id}`"
                  variant="link"
                  style="padding-top: 10px; padding-bottom: 10px;"
                  class="text-left d-flex justify-content-between align-items-center px-1"
                >
                  <div class="d-flex align-items-center" style="min-width: 0;">
                    <feather-icon icon="CpuIcon" size="14" class="mr-1" style="flex-shrink: 0;" />
                    <div style="display: flex; flex-direction: column; line-height: 1.2; min-width: 0;">
                      <span
                        class="device-name"
                        style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                        v-b-tooltip.hover.top="bridge.name"
                      >
                        {{ bridge.name }}
                      </span>
                      <span style="font-size: 10px; color: #9e9e9e;">Panel Bosch</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <b-badge
                      :variant="allBridgeDevicesUsed(bridge) ? 'secondary' : 'primary'"
                      style="margin-right:5px;"
                      v-b-tooltip.hover.top="allBridgeDevicesUsed(bridge) ? 'Todos los dispositivos están en uso' : ''"
                    >
                      {{ countBridgeDevices(bridge) }}
                    </b-badge>
                    <b-badge
                      v-b-tooltip.hover.top
                      title="Agregar todo"
                      variant="primary"
                      style="margin-right:5px; cursor:pointer;"
                      @click.stop="addAllToPlane(getBridgeDevices(bridge))"
                    >
                      <feather-icon icon="PlusIcon" size="13" />
                    </b-badge>
                    <feather-icon icon="ChevronDownIcon" size="14" />
                  </div>
                </b-button>
              </b-card-header>
              <b-collapse :id="`collapse-bosch-${bridge.camera_proxy_id}`" accordion="accordion-devices" >
                <b-card-body style="background: #f8f9fa; padding: 5px;">

                  <div style="padding: 4px 0;">
                    <b-form-input
                      :value="getBridgeFilter(bridge.camera_proxy_id)"
                      @input="setBridgeFilter(bridge.camera_proxy_id, $event)"
                      size="sm"
                      placeholder="Buscar..."
                      @click.stop
                      style="font-size: 12px;"
                    />
                  </div>

                  <AlarmBridgeBosch
                    :camera="bridge"
                    :setImage="setImage"
                    :usedDeviceIds="usedDeviceIds"
                    :cameraList="cameras"
                    :hideHeader="true"
                    :filter="getBridgeFilter(bridge.camera_proxy_id)"
                    @drag-device="startDrag"
                  />
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- DMP -->
            <b-card
              v-else-if="bridge.devices && (bridge.camera_type === 'alarm_bridge_dmp')"
              :key="`bosch-wrap-${bridge.camera_proxy_id}`"
              no-body
              style="margin: 0px;"
            >
              <b-card-header header-tag="div" class="p-0 border rounded">
                <b-button
                  block
                  v-b-toggle="`collapse-bosch-${bridge.camera_proxy_id}`"
                  variant="link"
                  style="padding-top: 10px; padding-bottom: 10px;"
                  class="text-left d-flex justify-content-between align-items-center px-1"
                >
                <div class="d-flex align-items-center" style="min-width: 0;">
                  <feather-icon icon="CpuIcon" size="14" class="mr-1" style="flex-shrink: 0;" />
                  <div style="display: flex; flex-direction: column; line-height: 1.2; min-width: 0;">
                    <span
                      class="device-name"
                      style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                      v-b-tooltip.hover.top="bridge.name"
                    >
                      {{ bridge.name }}
                    </span>
                    <span style="font-size: 10px; color: #9e9e9e;">Panel DMP</span>
                  </div>
                </div>
                  <div class="d-flex align-items-center">
                    <b-badge
                      :variant="allBridgeDevicesUsed(bridge) ? 'secondary' : 'primary'"
                      style="margin-right:5px;"
                      v-b-tooltip.hover.top="allBridgeDevicesUsed(bridge) ? 'Todos los dispositivos están en uso' : ''"
                    >
                      {{ countBridgeDevices(bridge) }}
                    </b-badge>
                    <b-badge
                      v-b-tooltip.hover.top
                      title="Agregar todo"
                      variant="primary"
                      style="margin-right:5px; cursor:pointer;"
                      @click.stop="addAllToPlane(getBridgeDevices(bridge))"
                    >
                      <feather-icon icon="PlusIcon" size="13" />
                    </b-badge>
                    <feather-icon icon="ChevronDownIcon" size="14" />
                  </div>
                </b-button>
              </b-card-header>
              <b-collapse :id="`collapse-bosch-${bridge.camera_proxy_id}`" accordion="accordion-devices" >
                <b-card-body style="background: #f8f9fa; padding: 5px;">

                  <div style="padding: 4px 0;">
                    <b-form-input
                      :value="getBridgeFilter(bridge.camera_proxy_id)"
                      @input="setBridgeFilter(bridge.camera_proxy_id, $event)"
                      size="sm"
                      placeholder="Buscar..."
                      @click.stop
                      style="font-size: 12px;"
                    />
                  </div>

                  <AlarmBridgeBosch
                    :camera="bridge"
                    :setImage="setImage"
                    :usedDeviceIds="usedDeviceIds"
                    :cameraList="cameras"
                    :hideHeader="true"
                    :filter="getBridgeFilter(bridge.camera_proxy_id)"
                    @drag-device="startDrag"
                  />
                </b-card-body>
              </b-collapse>
            </b-card>

            </template>

            <!-- ── Actuators / Density ────────────────────────────── -->
            <b-card no-body style="margin: 0px;" v-if="groupedCameras.actuators.length">
              <b-card-header header-tag="div" class="p-0 border rounded">
                <b-button
                  block
                  v-b-toggle="'collapse-actuators'"
                  variant="link"
                  style="padding-top: 10px; padding-bottom: 10px;"
                  class="text-left d-flex justify-content-between align-items-center px-1"
                >
                  <div class="d-flex align-items-center">
                    <feather-icon icon="ZapIcon" size="14" />
                    <span class="device-name">{{ 'Actuadores' }}</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <b-badge
                      :variant="allDevicesUsed(groupedCameras.actuators) ? 'secondary' : 'primary'"
                      style="margin-right:5px;"
                      v-b-tooltip.hover.top="allDevicesUsed(groupedCameras.actuators) ? 'Todos los dispositivos están en uso' : ''"
                    >
                      {{ groupedCameras.actuators.length }}
                    </b-badge>
                    <!-- Actuadores -->
                    <b-badge
                      v-b-tooltip.hover.top
                      title="Agregar todo"
                      variant="primary"
                      style="margin-right:5px; cursor:pointer;"
                      @click.stop="addAllToPlane(groupedCameras.actuators)"
                    >
                      <feather-icon icon="PlusIcon" size="13" />
                    </b-badge>

                    <feather-icon icon="ChevronDownIcon" size="14" />
                  </div>
                </b-button>
              </b-card-header>
              <b-collapse id="collapse-actuators" accordion="accordion-devices">
                <b-card-body style="background: #f8f9fa; padding: 1px;">

                  <div style="padding: 4px;">
                    <b-form-input
                      v-model="filters.actuators"
                      size="sm"
                      placeholder="Buscar..."
                      @click.stop
                      style="font-size: 12px;"
                    />
                  </div>

                  <div
                    v-for="camera in filteredActuators"
                    :key="camera.camera_proxy_id"
                    class="device-item d-flex justify-content-start align-items-center border rounded mb-1"
                    :draggable="!usedDeviceIds.has(camera.camera_proxy_id)"
                    :style="usedDeviceIds.has(camera.camera_proxy_id) ? { opacity: 0.4, cursor: 'not-allowed' } : {}"
                    @dragstart="!usedDeviceIds.has(camera.camera_proxy_id) && startDrag(camera)"
                  >
                    <img :src="setImage(camera)" width="18px" />
                    <span class="status-dot ml-1"></span>
                    <span class="device-name ml-1">{{ camera.name }}</span>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- ── Router ─────────────────────────────────────────── -->
            <b-card no-body style="margin: 0px;" v-if="groupedCameras.router">
                <b-card-header header-tag="div" class="p-0 border rounded">
                  <b-button
                    block
                    v-b-toggle="'collapse-router'"
                    variant="link"
                    style="padding-top: 10px; padding-bottom: 10px;"
                    class="text-left d-flex justify-content-between align-items-center px-1"
                  >
                    <div class="d-flex align-items-center">
                      <feather-icon icon="WifiIcon" size="14" class="mr-1"/>
                      <span class="device-name">Router</span>
                    </div>
                    <div class="d-flex align-items-center">
                      <!-- <b-badge variant="primary" style="margin-right:5px;">1</b-badge> -->
                      <feather-icon icon="ChevronDownIcon" size="14" />
                    </div>
                  </b-button>
                </b-card-header>
              <b-collapse id="collapse-router" accordion="accordion-devices">
                <b-card-body style="background: #f8f9fa; padding: 3px;">
                  <div
                    class="device-item d-flex justify-content-start align-items-center border rounded"
                    :draggable="!usedDeviceIds.has(groupedCameras.router.camera_proxy_id)"
                    :style="usedDeviceIds.has(groupedCameras.router.camera_proxy_id) ? { opacity: 0.4, cursor: 'not-allowed' } : {}"
                    style="margin: 3px; background: white;"
                    @dragstart="!usedDeviceIds.has(groupedCameras.router.camera_proxy_id) && startDrag(groupedCameras.router)"
                  >
                    <img :src="setImage(groupedCameras.router)" width="18px" />
                    <span class="status-dot"></span>
                    <span class="device-name">{{ groupedCameras.router.name }}</span>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- ── Alarms ───────────────────────────────────── -->
            <b-card no-body style="margin: 0px;" v-if="groupedCameras.falseAlarms.length">
              <b-card-header header-tag="div" class="p-0 border rounded">
                <b-button
                  block
                  v-b-toggle="'collapse-false-alarms'"
                  variant="link"
                  style="padding-top: 10px; padding-bottom: 10px;"
                  class="text-left d-flex justify-content-between align-items-center px-1"
                >
                  <div class="d-flex align-items-center">
                    <feather-icon icon="PocketIcon" size="14" class="mr-1" />
                    <span class="device-name">Alarmas</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <b-badge
                      :variant="allDevicesUsed(groupedCameras.falseAlarms) ? 'secondary' : 'primary'"
                      style="margin-right:5px;"
                      v-b-tooltip.hover.top="allDevicesUsed(groupedCameras.falseAlarms) ? 'Todos los dispositivos están en uso' : ''"
                    >
                      {{ groupedCameras.falseAlarms.length }}
                    </b-badge>
                    <!-- Alarmas -->
                    <!-- <b-badge
                      v-b-tooltip.hover.top
                      title="Agregar todo"
                      variant="primary"
                      style="margin-right:5px; cursor:pointer;"
                      @click.stop="addAllToPlane(groupedCameras.falseAlarms)"
                    >
                      <feather-icon icon="PlusIcon" size="13" />
                    </b-badge> -->
                    <feather-icon icon="ChevronDownIcon" size="14" />
                  </div>
                </b-button>
              </b-card-header>
              <b-collapse id="collapse-false-alarms" accordion="accordion-devices">
                <b-card-body style="background: #f8f9fa; padding: 1px;">

                  <div style="padding: 4px;">
                    <b-form-input
                      v-model="filters.falseAlarms"
                      size="sm"
                      placeholder="Buscar..."
                      @click.stop
                      style="font-size: 12px;"
                    />
                  </div>

                  <div
                  v-for="alarm in filteredFalseAlarms"
                  :key="alarm.id"
                  class="device-item d-flex justify-content-start align-items-center border rounded"
                  style="margin: 3px; background: white;"
                  :draggable="!usedDeviceIds.has(alarm.id)"
                  :style="usedDeviceIds.has(alarm.id)
                    ? { opacity: 0.4, cursor: 'not-allowed' }
                    : { cursor: 'grab' }"
                  @dragstart="!usedDeviceIds.has(alarm.id) && startDrag(alarm)"
                  >
                    <!-- CustomIcon con el color de la alarma -->
                    <CustomIcon
                      v-if="alarm.icon"
                      :name="alarm.icon"
                      :size="20"
                      :color="alarm.color || '#6c757d'"
                      style="flex-shrink: 0; margin-left: 4px;"
                    />
                    <!-- Fallback acronym si no hay icon -->
                    <div
                      v-else
                      style="
                        min-width: 22px; height: 22px;
                        border-radius: 4px; flex-shrink: 0;
                        display: flex; align-items: center; justify-content: center;
                        font-size: 9px; font-weight: 700; margin-left: 4px;
                      "
                      :style="{
                        backgroundColor: alarm.color || '#6c757d',
                        color: alarm.text_color || 'white',
                      }"
                    >
                      {{ alarm.acronym || '?' }}
                    </div>

                    <span
                      class="device-name"
                      v-b-tooltip.hover
                      :title="alarm.name"
                    >
                      {{
                        alarm.name
                          ? (alarm.name.length > 20
                              ? alarm.name.substring(0, 20) + '...'
                              : alarm.name)
                          : ''
                      }}
                    </span>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- ── Otros ──────────────────────────────────────────── -->
            <b-card no-body style="margin: 0px;" v-if="groupedCameras.others.length">
              <b-card-header header-tag="div" class="p-0 border rounded">
                <b-button
                  block
                  v-b-toggle="'collapse-others'"
                  variant="link"
                  style="padding-top: 10px; padding-bottom: 10px;"
                  class="text-left d-flex justify-content-between align-items-center px-1"
                >
                  <div class="d-flex align-items-center">
                    <feather-icon icon="BoxIcon" size="14" class="mr-1"/>
                    <span class="device-name">{{ 'Otros' }}</span>
                  </div>

                  <div class="d-flex align-items-center">
                    <b-badge
                      :variant="allDevicesUsed(groupedCameras.others) ? 'secondary' : 'primary'"
                      style="margin-right:5px;"
                      v-b-tooltip.hover.top="allDevicesUsed(groupedCameras.others) ? 'Todos los dispositivos están en uso' : ''"
                    >
                      {{ groupedCameras.others.length }}
                    </b-badge>
                    <!-- Others -->
                    <b-badge
                      v-b-tooltip.hover.top
                      title="Agregar todo"
                      variant="primary"
                      style="margin-right:5px; cursor:pointer;"
                      @click.stop="addAllToPlane(groupedCameras.others)"
                    >
                      <feather-icon icon="PlusIcon" size="13" />
                    </b-badge>
                    <feather-icon icon="ChevronDownIcon" size="14" />
                  </div>
                  
                </b-button>
              </b-card-header>
              <b-collapse id="collapse-others" accordion="accordion-devices">
                <b-card-body style="background: #f8f9fa; padding: 1px">

                  <div style="padding: 4px;">
                    <b-form-input
                      v-model="filters.others"
                      size="sm"
                      placeholder="Buscar..."
                      @click.stop
                      style="font-size: 12px;"
                    />
                  </div>

                  <div
                    v-for="camera in filteredOthers"
                    :key="camera.camera_proxy_id"
                    class="device-item d-flex justify-content-start align-items-center border rounded"
                    :draggable="!usedDeviceIds.has(camera.camera_proxy_id)"
                    :style="usedDeviceIds.has(camera.camera_proxy_id) ? { opacity: 0.4, cursor: 'not-allowed' } : {}"
                    style="margin: 3px; background: white;"
                    @dragstart="!usedDeviceIds.has(camera.camera_proxy_id) && startDrag(camera)"
                  >
                    <img :src="setImage(camera)" width="18px" />
                    <span class="status-dot"></span>
                    <span class="device-name">{{ camera.name }}</span>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>

          </div>
        </div>
      </template>

      <!-- No que? -->
      <li v-if="cameras.length == 0">
        <h4 class="text-cameras">No {{ $t("plane.devices") }}</h4>
      </li>

    </div>

    <!-- Contenedor para drag and drop-->
    <div class="col border rounded p-1" style="margin:10px; min-width: 0;">
       
      <!-- Si está cargando -->
      <div v-if="isLoading" class="h-100">
        <!-- Titulo -->
        <h4 class="d-flex align-items-center gap-1">
          <b-spinner small class="mx-1" />...
        </h4>

        <div class="border rounded" style="background-color: #f2f2f2;">
          <!-- Skeleton tabs -->
          <div class="skeleton-tabs">
            <div class="skeleton-tab" />
            <div class="skeleton-tab" />
            <div class="skeleton-tab skeleton-tab--add" />
          </div>

          <!-- Skeleton viewport -->
          <div class="skeleton-viewport">
            <div class="skeleton-shimmer" />

            <!-- Icono y spinner centrados -->
            <div class="skeleton-center-content">
              <b-icon icon="card-image" font-scale="4" class="skeleton-center-icon" />
              <b-spinner class="skeleton-center-spinner" />
            </div>

            <!-- Skeleton botones esquina -->
            <div class="skeleton-btn skeleton-btn--top" />
            <div class="skeleton-btn skeleton-btn--mid" />
          </div>
        </div>
      </div>

      <template v-if="!isLoading">
        <!-- Titulo -->
        <h4>{{ $t("plane.title") }}</h4>

        <!-- Todos los planos -->
        <div class="border rounded p-1" style="background-color: #f2f2f2;">
          
          <!-- Tabs -->
          <ul class="nav nav-tabs">
            <li
              class="nav-item"
              v-for="(plane, index) in planes"
              :key="plane.id"
              draggable="true"
              @dragstart="onTabDragStart(index)"
              @dragover.prevent
              @drop.stop="onTabDrop(index)"
              @dragend="onTabDragEnd"
              :class="{ 'tab-dragging': draggingTabIndex === index, 'tab-drag-over': draggingTabIndex !== null && draggingTabIndex !== index }"
            >
              <!-- Modo edición -->
              <input
                v-if="editingPlaneIndex === index"
                class="nav-link-input"
                v-model="editingPlaneName"
                maxlength="50"
                @blur="saveEditPlane(plane)"
                @keyup.enter="saveEditPlane(plane)"
                @keyup.esc="editingPlaneIndex = null"
                v-focus
              />

              <!-- Modo normal -->
              <button
                v-else
                class="nav-link"
                :class="{ active: activeTab === index }"
                :title="plane.name.length > 15 ? plane.name : ''"
                @click="activeTab = index"
                @dblclick.stop="startEditPlane(index, plane.name)"
              >
                <span class="tab-name">{{ plane.name }}</span>
                <span
                  v-if="modifiedTabs.has(plane.id)"
                  class="tab-modified-dot"
                  title="Cambios sin guardar"
                />
              </button>
            </li>

            <!-- Tab agregar plano — no es draggable -->
            <li class="nav-item">
              <button
                class="nav-link"
                :class="{ active: activeTab === planes.length }"
                @click="activeTab = planes.length"
              >
                {{ $t('plane.add') }} {{ $t('plane.title') }}
              </button>
            </li>
          </ul>

          <!-- Contenedor -->
          <div class="tab-content border rounded bg-white p-1">

          <!-- Tabs de planos existentes -->
          <div
            v-for="(plane, index) in planes"
            :key="plane.id"
            v-show="activeTab === index"
          >
            <div 
              class="contenedorPlane template"
              @dragenter.prevent="dragCounter++"
              @dragover.prevent
              @dragleave="dragCounter--"
              @drop="dropDevice($event, plane, index)"
            >
              <div 
                class="planeViewport"
                :class="{ 'drop-active': isDraggingOver }"
                @wheel="onWheel($event, index)"
                @pointerdown="startPan($event, index)"
                @pointermove="movePan($event, index)"
                @pointerup="endPan(index)"
                @pointerleave="endPan(index)"
              >
                <div class="planeScene" :style="sceneTransformForIndex(index)">
                  <img
                    :src="plane.path ? plane.path : plane._localPreview"
                    class="planeImage"
                    draggable="false"
                  />

                  <Device
                    v-for="(device, deviceIndex) in plane.devices.filter(d => d.device_type !== 'text')"
                    :key="device.id_generic || device.id_camera_proxy || device.id || `device-${index}-${deviceIndex}`"
                    :device="device"
                    :hasError="device._hasError || false"
                    :name="device.name"
                    :position="device.position"
                    :scale="getViewportState(index).scale"
                    :isCamera="device.device_type === 'camera'"
                    :showAlarm="false"
                    :readonly="false"
                    @update-position="updateDevicePosition(plane,$event)"
                    @update-rotation="updateDeviceRotation(plane,$event)"
                    @update-cone="updateDeviceCone(plane,$event)"
                    :showRadiusControl="false"
                    @update-radius="updateDeviceRadius(plane, $event)"
                    @remove="removeDevice(plane,$event)"
                  />

                  <TextElement
                    v-for="el in plane.devices.filter(d => d.device_type === 'text')"
                    :key="el.id"
                    :element="el"
                    :position="el.position"
                    :scale="getViewportState(index).scale"
                    :readonly="false"
                    :selected="selectedTextId === el.id"
                    @select="selectedTextId = el.id"
                    @deselect="selectedTextId = null"
                    @update-position="updateTextPosition(plane, $event)"
                    @update-text="updateTextContent(plane, $event)"
                    @update-style="updateTextStyle(plane, $event)"
                    @remove="removeDevice(plane, $event); selectedTextId = null"
                  />


                </div>
              </div>

              <!-- Botón cambiar imagen -->
              <b-button
                variant="primary"
                size="sm"
                style="position: absolute; top:45px; right: 8px; z-index: 9;"
                @click="$refs[`fileInputChange_${index}`][0].click()"
                v-b-tooltip.hover
                :title="'Cambiar imagen del plano'"
              >
                <b-icon icon="images" font-scale="1"/>
              </b-button>

              <!-- Input oculto para cambiar imagen -->
              <input
                :ref="`fileInputChange_${index}`"
                type="file"
                accept=".jpg,.jpeg,.png"
                style="display: none"
                @change="onChangeImage($event, plane, index)"
              />

              <b-button
                variant="secondary"
                size="sm"
                style="position: absolute; top: 8px; right: 8px; z-index: 9;"
                @click="confirmRemovePlane(plane, index)"
                v-b-tooltip.hover
                :title="'Borrar plano'"
              >
                <b-icon icon="trash" font-scale="1"/>
              </b-button>

              <!-- Toolbar de texto — fuera del planeScene para no escalar -->
              <transition name="toast-fade">
                <div
                  v-if="selectedTextId"
                  class="text-toolbar"
                  @pointerdown.stop
                  @click.stop
                >
                  <!-- Color de texto -->
                  <div class="text-toolbar__group">
                    <label class="text-toolbar__label">Color</label>
                    <input
                      type="color"
                      class="text-toolbar__color"
                      :value="getSelectedTextProp(plane, 'color') || '#000000'"
                      @input="updateTextStyle(plane, { element: { id: selectedTextId }, color: $event.target.value })"
                    />
                  </div>

                  <!-- Color de fondo -->
                  <div class="text-toolbar__group">
                    <label class="text-toolbar__label">Fondo</label>
                    <input
                      type="color"
                      class="text-toolbar__color"
                      :value="getSelectedTextBgHex(plane)"
                      @input="updateTextStyle(plane, { element: { id: selectedTextId }, background: $event.target.value })"
                    />
                  </div>

                  <!-- Fondo transparente toggle -->
                  <div class="text-toolbar__group">
                    <label class="text-toolbar__label">Transp.</label>
                    <input
                      type="checkbox"
                      :checked="getSelectedTextProp(plane, 'background') === 'transparent'"
                      @change="updateTextStyle(plane, { element: { id: selectedTextId }, background: $event.target.checked ? 'transparent' : '#ffffff' })"
                    />
                  </div>

                  <!-- Font size -->
                  <div class="text-toolbar__group">
                    <label class="text-toolbar__label">Tamaño</label>
                    <input
                      type="number"
                      class="text-toolbar__number"
                      min="8"
                      max="72"
                      :value="getSelectedTextProp(plane, 'fontSize') || 14"
                      @change="updateTextStyle(plane, { element: { id: selectedTextId }, fontSize: parseInt($event.target.value) })"
                    />
                  </div>

                  <!-- Cerrar -->
                  <button class="text-toolbar__close" @click.stop="selectedTextId = null">✕</button>
                </div>
              </transition>

            </div>
          </div>

          <!-- Tab agregar plano — siempre al final -->
          <div v-show="activeTab === planes.length">
            <div
              class="custom-dropzone"
              :class="{ 'custom-dropzone--active': isDropzoneOver }"
              @dragenter.prevent="isDropzoneOver = true"
              @dragover.prevent="isDropzoneOver = true"
              @dragleave="isDropzoneOver = false"
              @drop.prevent="onImageDrop"
              @click="$refs.fileInput.click()"
            >
              <b-icon icon="cloud-upload" font-scale="3" class="mb-2" />
              <p class="mb-0">{{ $t('plane.image') }}</p>
              <small class="text-muted">Click o arrastra una imagen aquí</small>
              <small class="text-muted mt-1">Formatos permitidos: .jpg, .jpeg, .png</small>
              <input
                ref="fileInput"
                type="file"
                accept=".jpg,.jpeg,.png"
                style="display: none"
                @change="onFileSelect"
              />
            </div>
          </div>

          </div>

        </div>
      </template>

    </div>

  </div>

  <!-- Toast manual -->
  <transition name="toast-fade">
    <div
      v-if="toast.show"
      class="manual-toast"
      :class="toast.type === 'success' ? 'manual-toast--success' : toast.type === 'error' ? 'manual-toast--error' : 'manual-toast--warning'"
    >
      <span>{{ toast.message }}</span>
    </div>
  </transition>

  <!-- Modal confirmación borrar plano -->
  <b-modal
    v-model="showDeleteModal"
    centered
    hide-header-close
    :title="$t('messages.delete.title')"
    @hide="cancelRemovePlane"
  >
    <p>
      ¿Estás seguro que deseas eliminar el plano
      <strong>{{ planeToDelete && planeToDelete.plane ? planeToDelete.plane.name : '' }}</strong>?
      Esta acción no se puede deshacer.
    </p>

    <template #modal-footer>
      <b-button variant="outline-secondary" @click="cancelRemovePlane">
        {{ $t('actions.cancel') }}
      </b-button>
      <b-button variant="danger" @click="executeRemovePlane">
        {{ $t('actions.delete') }}
      </b-button>
    </template>
  </b-modal>
</div>

</template>

<script>
import router from '@/router'
import { ref, onMounted, computed, set } from "@vue/composition-api"
import store from "@/store"
import Device from "./Device.vue"
import TextElement from "./TextElement.vue"
import setDeviceImage from './useList.js';
import AlarmBridgePacom from './devices/alarmBridgePacom.vue';
import AlarmBridgeBosch from "./devices/alarmBridgeBosch.vue";
import CustomIcon from '@/components/CustomIcon.vue'

export default {
  components: {
    Device,
    TextElement,
    AlarmBridgePacom,
    AlarmBridgeBosch,
    CustomIcon,
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus()
        el.select()
      }
    },
    'click-outside': {
      bind(el, binding) {
        el._clickOutside = (e) => {
          if (!el.contains(e.target)) binding.value(e)
        }
        document.addEventListener('click', el._clickOutside)
      },
      unbind(el) {
        document.removeEventListener('click', el._clickOutside)
      }
    }
  },
  setup() {

    const filters = ref({
      cameras:     '',
      actuators:   '',
      router:      '',
      falseAlarms: '',
      others:      '',
      bridges:     {}, // keyed por camera_proxy_id del bridge
    })

    // ─── ID de la unidad actual ───────────────────────────────────────────────
    const id = router.currentRoute.params.id

    // ─── Estado general ───────────────────────────────────────────────────────
    const cameras    = ref([])
    const planes     = ref([])
    const arrayCameras = ref([])
    const isLoading  = ref(true)
    const isSaving = ref(false)
    const textImage  = require("@/assets/images/text-icon.png")

    // ─── Toast manual ─────────────────────────────────────────────────────────────
    const toast = ref({ show: false, message: '', type: 'success' })
    let toastTimer = null

    const showToast = (message, type = 'success') => {
      if (toastTimer) clearTimeout(toastTimer)
      toast.value = { show: true, message, type }
      toastTimer = setTimeout(() => {
        toast.value.show = false
      }, 3000)
    }

    const MAX_IMAGE_SIZE_MB = 5
    const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024

    const isValidImage = (file) => {
      const allowed = ['image/jpeg', 'image/jpg', 'image/png']
      if (!allowed.includes(file.type)) return 'format'
      if (file.size > MAX_IMAGE_SIZE_BYTES) return 'size'
      return true
    }

    // ─── Zoom y pan del plano ─────────────────────────────────────────────────
    const viewportStates = ref({})

    const getViewportState = (index) => {
      if (!viewportStates.value[index]) {
        set(viewportStates.value, index, {
          scale:      1,
          translateX: 0,
          translateY: 0,
          isPanning:  false,
          startX:     0,
          startY:     0,
        })
      }
      return viewportStates.value[index]
    }

    const sceneTransformForIndex = (index) => {
      const s = getViewportState(index)
      return {
        transform: `translate(${s.translateX}px, ${s.translateY}px) scale(${s.scale})`
      }
    }

    const onWheel = (e, index) => {
      e.preventDefault()
      const s = getViewportState(index)

      const zoomIntensity = 0.001
      const delta    = -e.deltaY
      const newScale = Math.min(Math.max(0.3, s.scale + delta * zoomIntensity), 4)
      const rect     = e.currentTarget.getBoundingClientRect()
      const mouseX   = e.clientX - rect.left
      const mouseY   = e.clientY - rect.top
      const scaleFactor = newScale / s.scale

      s.translateX = mouseX - scaleFactor * (mouseX - s.translateX)
      s.translateY = mouseY - scaleFactor * (mouseY - s.translateY)
      s.scale = newScale

      markTabModified(index)
    }

    const startPan = (e, index) => {
      if (!e.shiftKey) return
      const s = getViewportState(index)
      s.isPanning = true
      s.startX = e.clientX - s.translateX
      s.startY = e.clientY - s.translateY
    }

    const movePan = (e, index) => {
      const s = getViewportState(index)
      if (!s.isPanning) return
      s.translateX = e.clientX - s.startX
      s.translateY = e.clientY - s.startY
    }

    const endPan = (index) => {
      const s = getViewportState(index)
      s.isPanning = false
    }

    // ─── Drag and drop de devices al plano ───────────────────────────────────
    const draggedDevice  = ref(null)
    const dragCounter    = ref(0)
    const isDraggingOver = computed(() => dragCounter.value > 0)
    const usedDeviceIds  = ref(new Set())

    const startDrag = (device) => {
      // console.log('Dragged device:', JSON.stringify(device, null, 2))
      draggedDevice.value = device
    }

    const dropDevice = (event, plane, index) => {
      dragCounter.value = 0
      if (!draggedDevice.value) return

      const isText      = draggedDevice.value.device_type === 'text'
        const isAlarm     = draggedDevice.value.device_type === 'alarm' || draggedDevice.value.camera_type === 'alarm'
        const isDmpStatus = draggedDevice.value.device_type === 'dmp_panel_status'

        if (!isText) {
          const idToMark = (isAlarm || isDmpStatus)
            ? (draggedDevice.value.id_generic || draggedDevice.value.id)
            : (draggedDevice.value.camera_proxy_id || draggedDevice.value.id_camera_proxy || draggedDevice.value.id)

          const alreadyInPlane = (isAlarm || isDmpStatus)
            ? plane.devices.some(d => d.id_generic === idToMark || d.id === idToMark)
            : plane.devices.some(d => d.id_camera_proxy === idToMark)

          if (alreadyInPlane) {
            draggedDevice.value = null
            return
          }

          usedDeviceIds.value = new Set([...usedDeviceIds.value, idToMark])
      }

      const s = getViewportState(index)
      const rect = event.currentTarget.getBoundingClientRect()
      const x = (event.clientX - rect.left - s.translateX) / s.scale
      const y = (event.clientY - rect.top  - s.translateY) / s.scale

      // Para texto, generamos un id único en el momento del drop
      const newId = isText ? `text-${Date.now()}` : null

      plane.devices.push({
        ...draggedDevice.value,
        id:              isText ? newId : (draggedDevice.value.id_generic || draggedDevice.value.id_camera_proxy || draggedDevice.value.id),
        id_generic:      isText ? newId : (draggedDevice.value.id_generic || null),
        id_camera_proxy: isText ? null  : (draggedDevice.value.camera_proxy_id || draggedDevice.value.id_camera_proxy || draggedDevice.value.id),
        name:            draggedDevice.value.name || draggedDevice.value.text || '',
        panel_device_type: draggedDevice.value.panel_device_type || draggedDevice.value.device_type || null,
        position: { x, y, width: isText ? 120 : 30, height: isText ? 40 : 30, cone: { visible: false, distance: 80, angle: 45 }, radius: { visible: false, size: 50 } }
      })

      draggedDevice.value = null
      markTabModified(index)
    }

    // ─── Actualizar posición, rotación y tamaño de devices en el plano ────────
    const updateDevicePosition = (plane, payload) => {
      const index = planes.value.indexOf(plane)
      const device = plane.devices.find(d => {
        if (payload.device.id_generic) return d.id_generic === payload.device.id_generic
        if (payload.device.id_camera_proxy) return d.id_camera_proxy === payload.device.id_camera_proxy
        return d.id === payload.device.id
      })
      if (device) {
        device.position = {
          ...device.position,
          x:      payload.position.x,
          y:      payload.position.y,
          width:  payload.position.width,
          height: payload.position.height,
        }
      }
      markTabModified(index)
    }

    const updateDeviceRotation = (plane, payload) => {
      const index = planes.value.indexOf(plane)
      const device = plane.devices.find(d => {
        if (payload.device.id_generic) return d.id_generic === payload.device.id_generic
        if (payload.device.id_camera_proxy) return d.id_camera_proxy === payload.device.id_camera_proxy
        return d.id === payload.device.id
      })
      if (device) {
        device.position = {
          ...device.position,
          degree: payload.degree
        }
      }
      markTabModified(index)
    }

    const removeDevice = (plane, device) => {
      const index = planes.value.indexOf(plane)

      plane.devices = plane.devices.filter(d => {
        if (device.id_generic) return d.id_generic !== device.id_generic
        if (device.id_camera_proxy) return d.id_camera_proxy !== device.id_camera_proxy
        return d.id !== device.id
      })

      const idToRelease = device.id_generic
                      ?? device.camera_proxy_id
                      ?? device.id_camera_proxy
                      ?? device.id

      usedDeviceIds.value = new Set(
        [...usedDeviceIds.value].filter(id => id !== idToRelease)
      )
      markTabModified(index)
    }

    const onChangeImage = (e, plane, index) => {
      const file = e.target.files[0]
      if (!file) return
      const valid = isValidImage(file)
      if (valid === 'format') {
        showToast('Archivo inválido. Solo se permiten imágenes .jpg, .jpeg o .png', 'error')
        e.target.value = ''
        return
      }
      if (valid === 'size') {
        showToast(`La imagen no puede superar ${MAX_IMAGE_SIZE_MB}MB`, 'error')
        e.target.value = ''
        return
      }

      // Revocar preview anterior si existe
      if (plane._localPreview) {
        URL.revokeObjectURL(plane._localPreview)
      }

      // Actualizar el plano con la nueva imagen
      plane._localFile    = file
      plane._localPreview = URL.createObjectURL(file)
      plane.path          = null  // forzamos usar _localPreview

      markTabModified(index)

      // Limpiar el input para permitir seleccionar el mismo archivo de nuevo
      e.target.value = ''
    }

    // ─── Collapsables de la lista de dispositivos ─────────────────────────────
    const activeTab = ref(0)
    const currentScale = computed(() => {
      return getViewportState(activeTab.value).scale
    })

    // ─── Imagen de cada device ────────────────────────────────────────────────
    const setImage = (camera) => {
      return setDeviceImage(camera)
    }


    // ─── Helpers para transformar datos de bridge ─────────────────────────────
    const getPanelDeviceType = (panel_device_type, prefix) => {
      if (panel_device_type === 'area') return `${prefix}_area`

      if (['door', 'output', 'zone', 'zone24h'].includes(panel_device_type)) {
        return `${prefix}_device`
      }

      return `${prefix}_panel`
    }

    const bridgeTransformData = (camera) => {
      const isDmpBridge       = camera.camera_type === 'alarm_bridge_dmp'
      const isIntelbrasBridge = camera.camera_type === 'alarm_bridge_intelbras'
      const isPacomBridge     = camera.camera_type === 'alarm_bridge_pacom'
      const isBoschBridge     = camera.camera_type === 'alarm_bridge_bosch'

      if      (isBoschBridge)     camera.type_device = 'bosch_panel'
      else if (isDmpBridge)       camera.type_device = 'dmp_panel'
      else if (isIntelbrasBridge) camera.type_device = 'intelbras_panel'
      else if (isPacomBridge)     camera.type_device = 'pacom_device'

      camera.device_id = camera.id
      return camera
    }


    // ─── Obtener devices de un bridge ─────────────────────────────────────────
    const getDevices = async (device_proxy_id, camera_type) => {
      let devices = []
      try {
        if (camera_type === 'alarm_bridge_dmp' || camera_type === 'alarm_bridge_bosch') {
          await store.dispatch("alarm_panels/getInfo", { device_proxy_id, withDevices: true })
          devices = store.getters["alarm_panels/getItems"].devices ?? []
          // console.log('devices Bosch/DMP:', JSON.stringify(devices, null, 2))
        } else {
          const response = await store.dispatch("intelbras_alarm_panels/getInfo", { 
            device_proxy_id, 
            withDevices: true 
          })
          devices = response.data.devices ?? []
        }
      } catch {
        devices = []
      }
      return devices
    }

    const buildBoschDevicesFromSummary = (summary, panelProxyId) => {
        if (!summary) return null

        const areas = (summary.areas || []).map(area => ({
          id:          String(area.id),
          device_id:   area.id,
          device_proxy_id: null,  // Bosch no tiene proxy por sub-device
          text:        area.name,
          device_type: 'area',
          status:      area.statusText ?? 'Unknown',
          icon:        'feather icon-grid',
          actions:     [],
          devices:     (area.zones || []).map(zone => ({
            id:          String(zone.id),
            device_id:   zone.id,
            device_proxy_id: null,
            text:        zone.name,
            device_type: 'zone',
            status:      zone.statusText ?? 'Unknown',
            icon:        'feather icon-cpu',
            actions:     [],
          }))
        }))

        const doors = (summary.doors || []).map(door => ({
          id:          String(door.id),
          device_id:   door.id,
          device_proxy_id: null,
          text:        door.name,
          device_type: 'door',
          status:      door.statusText ?? 'Unknown',
          icon:        'feather icon-circle',
          actions:     [],
        }))

        const outputs = (summary.outputs || []).map(output => ({
          id:          String(output.id),
          device_id:   output.id,
          device_proxy_id: null,
          text:        output.name,
          device_type: 'output',
          status:      output.statusText ?? 'Unknown',
          icon:        'feather icon-cpu',
          actions:     [],
        }))

        return {
          panel: {
            id:          String(panelProxyId),
            device_proxy_id: panelProxyId,
            text:        'Panel',
            device_type: 'panel',
            actions:     [],
          },
          areas,
          doors,
          outputs,
          zones:    [],
          zones24h: [],
        }
    }

    // --- Agregar todos
    const GRID_COLS     = 5
    const GRID_SPACING  = 80 
    const GRID_START_X  = 40
    const GRID_START_Y  = 40

    const addAllToPlane = (devices) => {
      const activePlane = planes.value[activeTab.value]
      if (!activePlane) return

      const planeIndex = activeTab.value
      let col = 0
      let row = 0

      devices.forEach(device => {
        const isAlarm     = device.device_type === 'alarm' || device.camera_type === 'alarm'
        const isDmpStatus = device.device_type === 'dmp_panel_status'
        const isDmpAction = device.device_type === 'dmp_panel_action'
        const isText      = device.device_type === 'text'

        const idToMark = (isAlarm || isDmpStatus)
          ? (device.id_generic || device.id)
          : (device.camera_proxy_id || device.id_camera_proxy || device.id)

        // Saltar si ya está en el plano
        const alreadyInPlane = (isAlarm || isDmpStatus)
          ? activePlane.devices.some(d => d.id_generic === idToMark || d.id === idToMark)
          : activePlane.devices.some(d => d.id_camera_proxy === idToMark)

        if (alreadyInPlane) return

        // Calcular posición en grid
        const x = GRID_START_X + (col * GRID_SPACING)
        const y = GRID_START_Y + (row * GRID_SPACING)

        activePlane.devices.push({
          ...device,
          id:              device.id_generic || device.id_camera_proxy || device.id,
          id_generic:      device.id_generic || null,
          id_camera_proxy: device.camera_proxy_id || device.id_camera_proxy || device.id,
          name:            device.name || device.text || '',
          panel_device_type: device.panel_device_type || device.device_type || null,
          position: {
            x, y,
            width:  30,
            height: 30,
            cone:   { visible: false, distance: 80, angle: 45 },
            radius: { visible: false, size: 50 }
          }
        })

        usedDeviceIds.value = new Set([...usedDeviceIds.value, idToMark])

        // Avanzar en grid
        col++
        if (col >= GRID_COLS) { col = 0; row++ }
      })

      markTabModified(planeIndex)
    }

    const getBridgeDevices = (bridge) => {
      if (!bridge.devices) return []
      const result = []
      for (const key in bridge.devices) {
        if (key === 'panel') continue
        if (Array.isArray(bridge.devices[key])) {
          bridge.devices[key].forEach(item => {

            // dmp_panel_status 
            if (key === 'dmp_panel_status') {
              result.push({
                id:              item.id,
                id_generic:      item.id,  
                id_camera_proxy: null,
                camera_proxy_id: null,
                name:            item.data?.name || item.id,
                device_type:     'dmp_panel_status',
                camera_type:     'dmp_panel_status',
                panel_device_type: 'dmp_panel_status',
                icon:            item.data?.icon      || null,
                value:           item.data?.value     || null,
                color:           item.data?.color     || null,
                color_icon:      item.data?.color_icon || null,
                text_color:      item.data?.text_color || null,
              })
              return
            }

            if (key === 'dmp_panel_actions') {
              result.push({
                id:              item.id,
                id_generic:      item.id,
                id_camera_proxy: null,
                camera_proxy_id: null,
                name:            item.data?.name      || item.id,
                device_type:     'dmp_panel_action',
                camera_type:     'dmp_panel_action',
                panel_device_type: 'dmp_panel_action',
                icon:            item.data?.icon      || null,
                color:           item.data?.color     || null,
                color_icon:      item.data?.color_icon || null,
                text_color:      item.data?.text_color || null,
                actions:         item.actions          || {},
              })
              return
            }

            const panelTypeMap = {
              areas:    'area',
              zones:    'zone',
              zones24h: 'zone24h',
              outputs:  'output',
              doors:    'door',
            }

            result.push({
              ...item,
              id:              item.device_proxy_id || item.id,
              id_generic:      null,
              id_camera_proxy: item.device_proxy_id,
              camera_proxy_id: item.device_proxy_id,
              name:            item.text || item.name || '',
              device_type:     'alarm_bridge_device',
              camera_type:     bridge.camera_type,
              panel_device_type: panelTypeMap[key] || key,
            })

            if (item.devices && Array.isArray(item.devices)) {
              item.devices.forEach(sub => {
                result.push({
                  ...sub,
                  id:              sub.device_proxy_id || sub.id,
                  id_generic:      null,
                  id_camera_proxy: sub.device_proxy_id,
                  camera_proxy_id: sub.device_proxy_id,
                  name:            sub.text || sub.name || '',
                  device_type:     'alarm_bridge_device',
                  camera_type:     bridge.camera_type,
                  panel_device_type: panelTypeMap[key] || key,
                })
              })
            }
          })
        }
      }
      return result
    }

    // Verifica si un id ya está usado en cualquier plano
    const isIdUsed = (id) => usedDeviceIds.value.has(id)

    // Verifica si todos los devices de una lista ya están en algún plano
    const allDevicesUsed = (devices) => {
      if (!devices || !devices.length) return false
      return devices.every(device => {
        const id = device.id_generic || device.camera_proxy_id || device.id_camera_proxy || device.id
        return usedDeviceIds.value.has(id)
      })
    }

    // Para bridges — verifica si todos sus sub-devices están usados
    const allBridgeDevicesUsed = (bridge) => {
      const devices = getBridgeDevices(bridge)
      if (!devices.length) return false
      return devices.every(device => {
        const id = device.id_generic || device.camera_proxy_id || device.id_camera_proxy || device.id
        return usedDeviceIds.value.has(id)
      })
    }

    // Helper para buscar latest_alarm de un device en el raw del panel
    const findLatestAlarmInDevices = (panelDevices, id_camera_proxy) => {
      if (!panelDevices || !id_camera_proxy) return null
      
      for (const key in panelDevices) {
        if (key === 'panel') continue
        if (Array.isArray(panelDevices[key])) {
          for (const item of panelDevices[key]) {
            if (String(item.device_proxy_id) === String(id_camera_proxy)) {
              return item.latest_alarm && !Array.isArray(item.latest_alarm) 
                ? item.latest_alarm : null
            }
            if (item.devices && Array.isArray(item.devices)) {
              for (const sub of item.devices) {
                if (String(sub.device_proxy_id) === String(id_camera_proxy)) {
                  return sub.latest_alarm && !Array.isArray(sub.latest_alarm)
                    ? sub.latest_alarm : null
                }
              }
            }
          }
        }
      }
      return null
    }

    // ─── Carga inicial de datos ───────────────────────────────────────────────
    const refetchData = async () => {
        isLoading.value = true

        const [res, relationsRes] = await Promise.all([
          store.dispatch("unit/get", id),
          store.dispatch("unit/getWithRelations", {
            id,
            params: { withCameras: false, withDevices: true, view: 'editor' }
          })
        ])

        const allCameras = res.data.cameras.filter(Boolean)

        // Actuators de getWithRelations — solo agrega los que no están ya en allCameras
        const actuators = relationsRes.data?.devices?.[0]?.actuators ?? []
        const mappedActuators = actuators
          .filter(a => !allCameras.some(c => c.camera_proxy_id === a.camera_proxy_id))
          .map(actuator => ({
            ...actuator,
            device_type:     'actuator',
            camera_proxy_id: actuator.camera_proxy_id,
            id_camera_proxy: actuator.camera_proxy_id,
            camera_type:     actuator.camera_type,
            name:            actuator.name,
            devices:         null,
          }))

        //Alarmas
        const alarms = relationsRes.data?.devices?.[0]?.alarms ?? []
        const mappedAlarms = alarms.map(alarm => ({
          id:              alarm.id,
          camera_proxy_id: alarm.id,
          id_camera_proxy: alarm.id,
          device_type:     'alarm',
          camera_type:     'alarm',
          name:            alarm.data?.name        ?? alarm.id,
          color:           alarm.data?.color       ?? null,
          text_color:      alarm.data?.text_color  ?? null,
          icon: alarm.data?.icon ?? 'NotificationsActive',  
          color_icon: alarm.data?.color_icon ?? '#ffffff', 
          acronym:         alarm.data?.acronym     ?? null,
          dispatch_url:    alarm.actions?.dispatch_alarm ?? null,
          devices:         null,
        }))
        
        // DMP Panel Status
        const dmpPanelStatuses = relationsRes.data?.devices?.[0]?.dmp_panel_status ?? []
        const mappedDmpStatuses = dmpPanelStatuses.map(status => ({
          id:              status.id,
          camera_proxy_id: status.id,
          id_camera_proxy: status.id,
          id_generic:      status.id,
          device_type:     'dmp_panel_status',
          camera_type:     'dmp_panel_status',
          panel_device_type: 'dmp_panel_status',
          name:            status.data?.name     ?? status.id,
          value:           status.data?.value    ?? null,
          color:           status.data?.color    ?? null,
          text_color:      status.data?.text_color ?? null,
          icon:            status.data?.icon     ?? null,
          color_icon:      status.data?.color_icon ?? null,
          devices:         null,
        }))


        // DMP Actions
        const dmpPanelActionsRaw = relationsRes.data?.devices?.[0]?.dmp_panel_actions ?? []
        const mappedDmpActions = dmpPanelActionsRaw.map(action => ({
          id:              action.id,
          camera_proxy_id: action.id,
          id_camera_proxy: action.id,
          id_generic:      action.id,
          device_type:     'dmp_panel_action',
          camera_type:     'dmp_panel_action',
          panel_device_type: 'dmp_panel_action',
          name:            action.data?.name      ?? action.id,
          color:           action.data?.color     ?? null,
          text_color:      action.data?.text_color ?? null,
          icon:            action.data?.icon      ?? null,
          color_icon:      action.data?.color_icon ?? null,
          actions:         action.actions         ?? {},
          devices:         null,
        }))

        // Merge único — normaliza density_device y agrega actuators extra y tambien las nuevas alarms
        cameras.value = [
          ...allCameras.map(camera => ({ ...camera, devices: null })), 
          ...mappedActuators,
          ...mappedAlarms,
        ]

        // Bridges: obtener sub-devices del store
        for (const camera of cameras.value) {
          if (camera.device_type === 'alarm_bridge') {
            if (camera.camera_type === 'alarm_bridge_dmp' || camera.camera_type === 'alarm_bridge_bosch') {
              camera.devices = await getDevices(camera.camera_proxy_id, camera.camera_type)
              
              // Inyectar dmp_panel_status en el bridge DMP
              if (camera.camera_type === 'alarm_bridge_dmp' && dmpPanelStatuses.length) {
                camera.devices = {
                  ...camera.devices,
                  dmp_panel_status: dmpPanelStatuses,
                  dmp_panel_actions: dmpPanelActionsRaw,
                }
              }
            } else if (camera.camera_type === 'alarm_bridge_pacom') {
              camera.devices = await getDevices(camera.camera_proxy_id, camera.camera_type)
            }
          }
        }

        // Cargar planos
        const floorPlantRes = await store.dispatch("unit/getFloorPlantAll", id)

        //para ordenar los planos con el order que nos agrego memo
        const sortedPlanes = (floorPlantRes.data || []).sort((a, b) => (a.order ?? 0) - (b.order ?? 0))

        planes.value = sortedPlanes.map(plane => {
        const mappedDevices = (plane.devices || []).map(device => {
          const matchedCamera = cameras.value.find(c => c.camera_proxy_id === device.id_camera_proxy)
          
          // Si tiene id_generic de alarma
          const isGenericAlarm = device.id_generic && String(device.id_generic).startsWith('alarm-')
          const matchedAlarm = isGenericAlarm
            ? mappedAlarms.find(a => a.id === device.id_generic)
            : null

          // Si tiene id_generic de dmp_panel_status
          const isDmpStatus = device.id_generic && String(device.id_generic).startsWith('dmp-status-')
          const isDmpAction = device.id_generic && String(device.id_generic).startsWith('dmp-action-')
          
          const dmpStatusData = isDmpStatus ? (mappedDmpStatuses.find(s => s.id === device.id_generic) ?? null) : null
          const dmpActionData = isDmpAction ? (mappedDmpActions.find(a => a.id === device.id_generic) ?? null) : null 

          // ── Inferir panel_device_type ─────────────────────────────────────
          const rawPanelType = device.device?.device_panel_type ?? null
          const cameraType   = device.device?.type ?? null

          const inferPanelType = (panelType, camType) => {
            if (panelType && panelType !== 'panel') return panelType
            if (!camType) return panelType
            const match = camType.match(/alarm_bridge_(.+)/)
            return match ? match[1] : panelType
          }

          const resolvedPanelType = inferPanelType(rawPanelType, cameraType)

          // Buscar el bridge padre para obtener sus devices cargados
          const parentBridge = cameras.value.find(c => 
            c.camera_proxy_id === device.device?.panel_proxy_id
          )
          const latestAlarm = findLatestAlarmInDevices(
            parentBridge?.devices, 
            device.id_camera_proxy
          ) ?? device.device?.latest_alarm ?? null

          return {
            id:              device.id_generic ?? device.id_camera_proxy,
            name:            dmpActionData?.name ?? dmpStatusData?.name ?? matchedAlarm?.name ?? matchedCamera?.name ?? device.device?.name ?? `Device ${device.id_camera_proxy}`,
            id_camera_proxy: device.id_camera_proxy,
            id_generic:      device.id_generic ?? null,
            device_type:     isDmpAction ? 'dmp_panel_action' : (isDmpStatus ? 'dmp_panel_status' : (isGenericAlarm ? 'alarm' : (matchedCamera?.device_type ?? device.device?.device_type ?? null))),
            camera_type:     isDmpAction ? 'dmp_panel_action' : (isDmpStatus ? 'dmp_panel_status' : (isGenericAlarm ? 'alarm' : (matchedCamera?.camera_type ?? device.device?.type ?? null))),
            id_type:         matchedCamera?.id_type        ?? null,
            id_type_sensor:  matchedCamera?.id_type_sensor ?? null,
            panel_device_type: isDmpAction ? 'dmp_panel_action' : (isDmpStatus ? 'dmp_panel_status' : (dmpStatusData?.panel_device_type ?? resolvedPanelType)),
            // Alarma
            icon:       dmpActionData?.icon       ?? dmpStatusData?.icon       ?? matchedAlarm?.icon       ?? null,
            color:      dmpActionData?.color      ?? dmpStatusData?.color      ?? matchedAlarm?.color      ?? null,
            color_icon: dmpActionData?.color_icon ?? dmpStatusData?.color_icon ?? matchedAlarm?.color_icon ?? null,
            text_color: dmpActionData?.text_color ?? dmpStatusData?.text_color ?? matchedAlarm?.text_color ?? null,
            acronym:    matchedAlarm?.acronym ?? null,
            // dmp_panel_status
            value:      dmpStatusData?.value ?? null,
            // dmp_panel_action
            actions:    dmpActionData?.actions ?? null,
            // Alarma genérica
            can_update_alarm: matchedAlarm?.can_update_alarm ?? false,
            dispatch_url:     matchedAlarm?.dispatch_url     ?? null,
            cancel_url:       matchedAlarm?.cancel_url       ?? null,
            position: {
              x:      device.x,
              y:      device.y,
              width:  device.width,
              height: device.height,
              degree: device.degree,
              cone: {
                visible:  !!device.cone_visible,
                distance: device.cone_distance ?? 80,
                angle:    device.cone_angle    ?? 45,
              },
              radius: { visible: false, size: 50 }
            },
            latest_alarm: latestAlarm,
          }
        })

          const uniqueDevices = mappedDevices.filter((device, index, self) =>
            index === self.findIndex(d =>
              d.id_generic
                ? d.id_generic === device.id_generic && d.position?.x === device.position?.x
                : d.id_camera_proxy === device.id_camera_proxy
            )
          )

          return {
            id:            plane.id,
            name:          plane.name,
            path:          plane.path,
            order:         plane.order,
            devices:       uniqueDevices,
            _floorPlantId: plane.id,
          }
        })

        // Restaurar zoom/pan por plano
        planes.value.forEach((plane, index) => {
          set(viewportStates.value, index, {
            scale:      parseFloat(plane.scale)       || 1,
            translateX: parseFloat(plane.translate_x) || 0,
            translateY: parseFloat(plane.translate_y) || 0,
            isPanning:  false,
            startX:     0,
            startY:     0,
          })
        })

        // Restaurar usedDeviceIds
        const allUsedIds = new Set()
        planes.value.forEach(plane => {
          plane.devices.forEach(device => {
            if (device.id_generic) allUsedIds.add(device.id_generic)  // cubre alarm- y dmp-status-
            else if (device.id_camera_proxy) allUsedIds.add(device.id_camera_proxy)
          })
        })
        usedDeviceIds.value = allUsedIds

        // Router
        const unitDescription = res.data.description
        const routerRes = await store.dispatch("router/get", res.data.id_router)
        cameras.value.push({
          id:              routerRes.data.id,
          id_router:       routerRes.data.id,
          id_camera_proxy: routerRes.data.id,
          camera_type:     "router",
          name:            unitDescription,
        })

        isLoading.value = false
    }

    // ─── Nuevo plano ──────────────────────────────────────────────────────────────
    const isDropzoneOver = ref(false)

    const onImageDrop = (e) => {
      isDropzoneOver.value = false
      const file = e.dataTransfer.files[0]
      if (!file) return
      const valid = isValidImage(file)
      if (valid === 'format') {
        showToast('Archivo inválido. Solo se permiten imágenes .jpg, .jpeg o .png', 'error')
        return
      }
      if (valid === 'size') {
        showToast(`La imagen no puede superar ${MAX_IMAGE_SIZE_MB}MB`, 'error')
        return
      }
      addLocalPlane(file)
    }

    const onFileSelect = (e) => {
      const file = e.target.files[0]
      if (!file) return
      const valid = isValidImage(file)
      if (valid === 'format') {
        showToast('Archivo inválido. Solo se permiten imágenes .jpg, .jpeg o .png', 'error')
        e.target.value = ''
        return
      }
      if (valid === 'size') {
        showToast(`La imagen no puede superar ${MAX_IMAGE_SIZE_MB}MB`, 'error')
        e.target.value = ''
        return
      }
      addLocalPlane(file)
    }

    const addLocalPlane = (file) => {
      const newPlane = {
        id:      `local_${Date.now()}`,   // id temporal
        name:    `Plano ${planes.value.length + 1}`,
        path:    null,
        devices: [],
        _localFile:    file,              // guardamos el archivo para enviarlo después
        _localPreview: URL.createObjectURL(file)  // URL para mostrar la imagen
      }

      planes.value.push(newPlane)
      activeTab.value = planes.value.length - 1  // ir directo a la nueva tab
    }

    // ─── Edición de nombre de plano ───────────────────────────────────────────────
    const editingPlaneIndex = ref(null)
    const editingPlaneName  = ref('')

    const startEditPlane = (index, name) => {
      editingPlaneIndex.value = index
      editingPlaneName.value  = name
    }

    const saveEditPlane = (plane) => {
      const index = planes.value.indexOf(plane)
      if (editingPlaneName.value.trim()) {
        plane.name = editingPlaneName.value.trim()
      }
      editingPlaneIndex.value = null
      editingPlaneName.value  = ''

      markTabModified(index)
    }

    // ─── Guardar estado de los planos ─────────────────────────────────────────────
    const savePlanes = async () => {

        // ─── Validación: al menos un plano debe tener devices ────────────────────
        const planesVacios = planes.value.filter(plane => plane.devices.length === 0)
        if (planesVacios.length === planes.value.length) {
          showToast('Debes agregar al menos un dispositivo a un plano antes de guardar', 'warning')
          return
        }

        // ─── Validación: cada plano debe tener al menos un device ────────────────
        const planoSinDevices = planes.value.find(plane => plane.devices.length === 0)
        if (planoSinDevices) {
          showToast(`El plano "${planoSinDevices.name}" no tiene dispositivos`, 'warning')
          return
        }

        isSaving.value = true
        let hasError = false


        for (const [index, plane] of planes.value.entries()) {
          try {
            const viewportState = getViewportState(index)
            const formData = new FormData()

            // Datos básicos
            formData.append('id_unit',     id)
            formData.append('name',        plane.name)
            formData.append('order',       index + 1)
            formData.append('scale',       Math.round(viewportState.scale))
            formData.append('translate_x', Math.round(viewportState.translateX))
            formData.append('translate_y', Math.round(viewportState.translateY))

            // Imagen
            if (plane._localFile) {
              formData.append('image', plane._localFile)
            } else if (plane.path) {
              const response = await fetch(plane.path)
              const blob     = await response.blob()
              const file     = new File([blob], 'plane.jpg', { type: 'image/jpeg' })
              formData.append('image', file, 'plane.jpg')
            } else {
              console.warn('⚠️ Sin imagen para el plano:', plane.name)
            }

            plane.devices.forEach((device, i) => {
              const isAlarm     = device.device_type === 'alarm' || device.camera_type === 'alarm'
              const isDmpStatus = device.device_type === 'dmp_panel_status'
              const isDmpAction = device.device_type === 'dmp_panel_action'
              const isGeneric   = isAlarm || isDmpStatus || isDmpAction 

              formData.append(`devices[${i}][id_camera_proxy]`,
                isGeneric ? '' : (device.id_camera_proxy ?? device.camera_proxy_id ?? '')
              )
              if (isGeneric) {
                formData.append(`devices[${i}][id_generic]`,
                  device.id_generic ?? device.id_camera_proxy ?? device.camera_proxy_id ?? device.id ?? null
                )
              }
              formData.append(`devices[${i}][x]`,             Math.round(device.position.x))
              formData.append(`devices[${i}][y]`,             Math.round(device.position.y))
              formData.append(`devices[${i}][width]`,         Math.round(device.position.width  || 30))
              formData.append(`devices[${i}][height]`,        Math.round(device.position.height || 30))
              formData.append(`devices[${i}][degree]`,        Math.round(device.position.degree || 0))
              formData.append(`devices[${i}][cone_visible]`,  (device.position?.cone?.visible ?? false) ? 1 : 0)
              formData.append(`devices[${i}][cone_distance]`, device.position?.cone?.visible ? (device.position?.cone?.distance ?? '') : '')
              formData.append(`devices[${i}][cone_angle]`,    device.position?.cone?.visible ? (device.position?.cone?.angle    ?? '') : '')
            })

            let result

            if (plane._floorPlantId) {
              result = await store.dispatch("unit/updateFloorPlant", {
                id:       plane._floorPlantId,
                formData: formData
              })
            } else {
              result = await store.dispatch("unit/addFloorPlant", formData)
            }

            // ── Manejar errores del backend ──────────────────────────────────
            if (result?.data && result.data.success === false) {
              const errorData = result.data.data || {}

              // Extraer índices con error: 
              const errorIndices = new Set()
              Object.keys(errorData).forEach(key => {
                const match = key.match(/^devices\.(\d+)\./)
                if (match) errorIndices.add(parseInt(match[1]))
              })

              // Marcar devices con error
              if (errorIndices.size > 0) {
                errorIndices.forEach(i => {
                  if (plane.devices[i]) {
                    plane.devices[i]._hasError = true
                  }
                })
                hasError = true
              }
            } else {
              // Guardar exitoso — limpiar errores de este plano
              plane.devices.forEach(d => { d._hasError = false })
            }
            // ─────────────────────────────────────────────────────────────────

          } catch (err) {
            console.error(`Error al guardar plano ${plane.name}:`, err)
            hasError = true
          }
        }

      isSaving.value = false 

      if (hasError) {
        showToast('Ocurrió un error al guardar los cambios', 'error')
      } else {
        showToast('Cambios guardados correctamente', 'success')
        modifiedTabs.value = new Set()
        await refetchData();
      }
    }

    const updateDeviceCone = (plane, payload) => {
      const index = planes.value.indexOf(plane)
      const device = plane.devices.find(d => {
        if (payload.device.id_generic) return d.id_generic === payload.device.id_generic
        if (payload.device.id_camera_proxy) return d.id_camera_proxy === payload.device.id_camera_proxy
        return d.id === payload.device.id
      })
      if (device) {
        device.position = {
          ...device.position,
          cone: { visible: payload.visible, distance: payload.distance, angle: payload.angle }
        }
      }
      markTabModified(index)
    }

    const removePlane = (plane, index) => {
      planes.value.splice(index, 1)

      // Limpiar el viewport state de ese plano
      delete viewportStates.value[index]

      // Si la tab activa era la que se eliminó o estaba más adelante, ajustarla
      if (activeTab.value >= planes.value.length) {
        activeTab.value = Math.max(0, planes.value.length - 1)
      }

      // Si el plano era local, liberar la URL del preview
      if (plane._localPreview) {
        URL.revokeObjectURL(plane._localPreview)
      }
    }

    // ─── Confirmación borrar plano ────────────────────────────────────────────────
    const showDeleteModal = ref(false)
    const planeToDelete   = ref(null)

    const confirmRemovePlane = (plane, index) => {
      planeToDelete.value = { plane, index }
      showDeleteModal.value = true
    }

    const cancelRemovePlane = () => {
      planeToDelete.value  = null
      showDeleteModal.value = false
    }

    const executeRemovePlane = async () => {
      if (!planeToDelete.value) return

      const { plane, index } = planeToDelete.value

      if (plane._floorPlantId) {
        try {
          await store.dispatch("unit/deleteFloorPlant", plane._floorPlantId)
          // console.log('Plano eliminado del back:', plane._floorPlantId)
        } catch (err) {
          console.error('Error al eliminar plano:', err)
          planeToDelete.value  = null
          showDeleteModal.value = false
          return
        }
      }

      // Liberamos los devices del plano eliminado (para poderlos volver a usar)
      const deviceIdsInPlane = new Set(plane.devices.map(d => d.id))
      usedDeviceIds.value = new Set(
        [...usedDeviceIds.value].filter(id => !deviceIdsInPlane.has(id))
      )

      removePlane(plane, index)

      planeToDelete.value  = null
      showDeleteModal.value = false
    }

    // ─── Popover de ayuda ─────────────────────────────────────────────────────────
    const showHelp = ref(false)

    // ─── Tabs modificados ─────────────────────────────────────────────────────────
    const modifiedTabs = ref(new Set())

    const markTabModified = (index) => {
      const plane = planes.value[index]
      if (!plane) return
      modifiedTabs.value = new Set([...modifiedTabs.value, plane.id]) 
    }

    // ─── Reordenar tabs ───────────────────────────────────────────────────────────
    const draggingTabIndex = ref(null)

    const onTabDragStart = (index) => {
      draggingTabIndex.value = index
    }

    const onTabDrop = (index) => {
      if (draggingTabIndex.value === null) return
      if (draggingTabIndex.value === index) return

      const from = draggingTabIndex.value

      const planesCopy = [...planes.value]
      const [moved] = planesCopy.splice(from, 1)
      planesCopy.splice(index, 0, moved)
      planes.value = planesCopy

      const oldStates = { ...viewportStates.value }
      const newStates = {}
      planesCopy.forEach((_, i) => {

        let oldI
        if (i === index) {
          oldI = from
        } else if (from < index) {
          oldI = i < from || i > index ? i : i + 1
        } else {
          oldI = i < index || i > from ? i : i - 1
        }
        newStates[i] = oldStates[oldI]
      })
      viewportStates.value = newStates

      activeTab.value = index
      draggingTabIndex.value = null
    }

    const onTabDragEnd = () => {
      draggingTabIndex.value = null
    }

    //Para el radius TEST 
    const updateDeviceRadius = (plane, payload) => {
      const device = plane.devices.find(d => {
        if (payload.device.id_generic) return d.id_generic === payload.device.id_generic
        if (payload.device.id_camera_proxy) return d.id_camera_proxy === payload.device.id_camera_proxy
        return d.id === payload.device.id
      })
      if (device) {
        device.position = {
          ...device.position,
          radius: { visible: payload.visible, size: payload.size }
        }
      }
    }

    //Para agrupar los dispositivos
    const groupedCameras = computed(() => {
      const groups = {
        bridges:  [],
        cameras:  [],
        actuators:[],
        falseAlarms:[],
        router:   null,
        others:   [],
      }

      cameras.value.forEach(camera => {
        if (camera.device_type === 'alarm_bridge') {
          groups.bridges.push(camera)
        } else if (camera.camera_type === 'router') {
          groups.router = camera
        } else if (camera.device_type === 'camera') {
          groups.cameras.push(camera)
        } else if (camera.camera_type === 'density_device' || camera.device_type === 'actuator') {
          groups.actuators.push(camera)
        } else if (camera.device_type === 'alarm' || camera.camera_type === 'alarm') {
          groups.falseAlarms.push(camera)
        } else if (
          camera.camera_type?.startsWith('alarm_bridge_') &&
          (camera.camera_type.includes('_device') || camera.camera_type.includes('_area'))
        ) {
          // sub-devices ocultos — ignorar
        } else {
          groups.others.push(camera)
        }
      })

      return groups
    })

    //Para contar cuantos dispositivos vienen
    const countBridgeDevices = (camera) => {
      if (!camera.devices) return 0
      if (Array.isArray(camera.devices)) return camera.devices.length

      // Para Bosch/DMP — objeto con keys (areas, zones, panel, etc)
      let count = 0
      Object.values(camera.devices).forEach(val => {
        if (Array.isArray(val)) {
          count += val.length
          // Contar sub-devices dentro de áreas
          val.forEach(item => {
            if (item.devices && Array.isArray(item.devices)) {
              count += item.devices.length
            }
          })
        } else if (val && typeof val === 'object') {
          count += 1 // panel
        }
      })
      return count
    }

    //Computed para buscar filtros
    const filteredCameras = computed(() =>
      groupedCameras.value.cameras.filter(c =>
        !filters.value.cameras ||
        c.name?.toLowerCase().includes(filters.value.cameras.toLowerCase())
      )
    )

    const filteredActuators = computed(() =>
      groupedCameras.value.actuators.filter(c =>
        !filters.value.actuators ||
        c.name?.toLowerCase().includes(filters.value.actuators.toLowerCase())
      )
    )

    const filteredFalseAlarms = computed(() =>
      groupedCameras.value.falseAlarms.filter(a =>
        !filters.value.falseAlarms ||
        a.name?.toLowerCase().includes(filters.value.falseAlarms.toLowerCase())
      )
    )

    const filteredOthers = computed(() =>
      groupedCameras.value.others.filter(c =>
        !filters.value.others ||
        c.name?.toLowerCase().includes(filters.value.others.toLowerCase())
      )
    )

    // Para bridges — cada bridge tiene su propio filtro por proxy_id
    const getBridgeFilter = (proxyId) => filters.value.bridges[proxyId] || ''
    const setBridgeFilter = (proxyId, val) => {
      filters.value.bridges = { ...filters.value.bridges, [proxyId]: val }
    }

    // drop de un texto 
    const addTextElement = () => {
      const activePlane = planes.value[activeTab.value]
      if (!activePlane) return

      const newText = {
        id:          `text-${Date.now()}`,
        id_generic:  `text-${Date.now()}`,
        id_camera_proxy: null,
        device_type: 'text',
        camera_type: 'text',
        text:        'Texto...',
        fontSize:    14,
        color:       '#000000',
        background:  'rgba(255,255,255,0.85)',
        position: {
          x: 100, y: 100,
          width: 120, height: 40,
          degree: 0,
          cone:   { visible: false, distance: 80, angle: 45 },
          radius: { visible: false, size: 50 },
        }
      }

      activePlane.devices.push(newText)
      markTabModified(activeTab.value)
    }

    const updateTextPosition = (plane, payload) => {
      const index = planes.value.indexOf(plane)
      const el = plane.devices.find(d => d.id === payload.element.id)
      if (el) el.position = { ...el.position, ...payload.position }
      markTabModified(index)
    }

    const updateTextContent = (plane, payload) => {
      const index = planes.value.indexOf(plane)
      const el = plane.devices.find(d => d.id === payload.element.id)
      if (el) el.text = payload.text
      markTabModified(index)
    }

    const startDragText = () => {
      draggedDevice.value = {
        id:              `text-${Date.now()}`,
        id_generic:      `text-${Date.now()}`,
        id_camera_proxy: null,
        device_type:     'text',
        camera_type:     'text',
        text:            'Texto...',
        fontSize:        14,
        color:           '#000000',
        background:      'rgba(255,255,255,0.85)',
      }
    }

    //Test para nuestro input text
    const selectedTextId = ref(null)

    const updateTextStyle = (plane, payload) => {
      const index = planes.value.indexOf(plane)
      const el = plane.devices.find(d => d.id === payload.element.id)
      if (el) {
        if (payload.fontSize !== undefined) el.fontSize = payload.fontSize
        if (payload.color    !== undefined) el.color    = payload.color
        if (payload.background !== undefined) el.background = payload.background
      }
      markTabModified(index)
    }

    const getSelectedTextProp = (plane, prop) => {
      if (!selectedTextId.value) return null
      const el = plane.devices.find(d => d.id === selectedTextId.value)
      return el ? el[prop] : null
    }

    // El color picker no entiende rgba, así que si el bg es rgba lo convertimos a hex
    const getSelectedTextBgHex = (plane) => {
      const bg = getSelectedTextProp(plane, 'background')
      if (!bg || bg === 'transparent') return '#ffffff'
      if (bg.startsWith('#')) return bg
      // rgba(255,255,255,0.85) → #ffffff aproximado
      const match = bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/)
      if (match) {
        return '#' + [match[1], match[2], match[3]]
          .map(n => parseInt(n).toString(16).padStart(2, '0'))
          .join('')
      }
      return '#ffffff'
    }

    onMounted(() => {
      refetchData()
    })

    // ─── Return ───────────────────────────────────────────────────────────────
    return {
      // Estado general
      id,
      cameras,
      planes,
      arrayCameras,
      isLoading,
      textImage,
      imageUrl: `${window.__env.VUE_APP_BASE_URL}/v1/plane/image?image=`,
      savePlanes,

      // Zoom y pan
      viewportStates,
      getViewportState,
      sceneTransformForIndex,
      onWheel,
      startPan,
      movePan,
      endPan,
      currentScale,

      // Drag and drop
      draggedDevice,
      dragCounter,
      isDraggingOver,
      usedDeviceIds,
      startDrag,
      dropDevice,

      // Devices en el plano
      updateDevicePosition,
      updateDeviceRotation,
      removeDevice,

      // Collapsables
      activeTab,

      // Imagen y helpers
      setImage,
      getDevices,
      getPanelDeviceType,
      bridgeTransformData,

      // Carga de datos
      refetchData,

      // Nuevo plano
      isDropzoneOver,
      onImageDrop,
      onFileSelect,
      updateDeviceCone,

      // Edición de nombre
      editingPlaneIndex,
      editingPlaneName,
      startEditPlane,
      saveEditPlane,

      // Confirmación borrar plano
      showDeleteModal,
      planeToDelete,
      confirmRemovePlane,
      cancelRemovePlane,
      executeRemovePlane,

      showHelp,
      modifiedTabs,
      markTabModified,

      draggingTabIndex,
      onTabDragStart,
      onTabDrop,
      onTabDragEnd,
      updateDeviceRadius,
      toast,
      showToast,
      isSaving,
      onChangeImage,
      buildBoschDevicesFromSummary,

      groupedCameras,
      countBridgeDevices,

      filters,
      filteredCameras,
      filteredActuators,
      filteredFalseAlarms,
      filteredOthers,
      getBridgeFilter,
      setBridgeFilter,

      addTextElement,
      updateTextPosition,
      updateTextContent,
      startDragText,
      selectedTextId,
      updateTextStyle,
      getSelectedTextProp,
      getSelectedTextBgHex,

      addAllToPlane,
      getBridgeDevices,
      allDevicesUsed,
      allBridgeDevicesUsed,
    }
  }
}
</script>
  
<style lang="scss" scoped>
.device-item {
  padding: 5px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.device-item:hover{
  background:#f4f4f4;
}

.device-item img {
  transition: transform 0.2s ease;
}

.device-item:hover img {
  transform: scale(1.1);
}

.device-name {
  font-size: 14px;
  padding-left: 5px;
}

.device-name-sub {
  font-size: 14px;
  padding-left: 5px;
}

.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-left: 5px;
  background-color: #28a745;
  display: inline-block;
}

.status-dot.off {
  background-color: #dc3545;
}
  
//Contenedor
.contenedorPlane {
  position: relative;
  width: 100%;
  overflow: visible;
}
  .plane-image {
  width: 100%;
  height: auto;
  display: block;
  position: relative;
  z-index: 1;
}

.planeViewport {
  width: 100%;
  height: 60vh;
  overflow: hidden;
  position: relative;
  cursor: grab;
  transition: box-shadow 0.2s ease, border 0.2s ease;
}

.planeViewport.drop-active {
  box-shadow: 
    inset 0 0 0 4px #007bff,
    inset 0 0 20px rgba(0, 123, 255, 0.2);
  background-color: rgba(0, 123, 255, 0.08);
  outline: 2px dashed #007bff;
  outline-offset: -4px;
}

.planeScene {
  position: absolute;
  transform-origin: top left;
}

.planeImage {
  display: block;
  user-select: none;
  pointer-events: none;
}

.device {
  position: absolute;
  z-index: 10;
}

.custom-dropzone {
  width: 100%;
  height: 60vh;
  border: 3px dashed #ccc;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fafafa;
  color: #aaa;

  &:hover {
    border-color: #007bff;
    color: #007bff;
    background: rgba(0, 123, 255, 0.03);
  }

  &--active {
    border-color: #007bff;
    background: rgba(0, 123, 255, 0.08);
    color: #007bff;
    box-shadow: inset 0 0 0 3px #007bff;
  }
}

.nav-link-input {
  border: none;
  border-bottom: 2px solid #007bff;
  outline: none;
  background: transparent;
  font-size: 14px;
  padding: 6px 8px;
  min-width: 80px;
  max-width: 150px;
  color: inherit;
}

.help-popover {
  position: absolute;
  top: 0px;
  left: 28px; 
  width: 220px;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  z-index: 100;
  font-size: 13px;

  &__arrow {
    position: absolute;
    top: 6px;
    left: -6px; 
    width: 10px;
    height: 10px;
    background: white;
    border-left: 1px solid #dee2e6;
    border-bottom: 1px solid #dee2e6;  
    transform: rotate(45deg);
  }

  &__title {
    font-weight: 600;
    margin-bottom: 8px;
    color: #495057;
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 6px;
  }
}

.tab-modified-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #ff9900;
  margin-left: 5px;
  vertical-align: middle;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0%   { opacity: 1; }
  50%  { opacity: 0.4; }
  100% { opacity: 1; }
}

// ─── Tabs ─────────────────────────────────────────────────────────────────────
.nav-tabs {
  border-bottom: none;
  gap: 4px;
  padding: 6px 6px 0 6px;
}

.nav-tabs .nav-item .nav-link {
  border: none;
  border-radius: 8px 8px 0 0;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 500;
  color: #385d7b;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(4px);
  transition: all 0.2s ease;
  position: relative;
  text-shadow: none;

  &:hover {
    background: rgba(255, 255, 255, 0.7);
    color: #495057;
  }

  &.active {
    background: #385d7b;  
    color: white;          
    font-weight: 600;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
    text-shadow: none;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: #385d7b;
      border-radius: 8px 8px 0 0;
    }
  }
}

// Input de edición dentro del tab
.nav-link-input {
  border: none;
  border-bottom: 2px solid white;  
  outline: none;
  background: #385d7b;            
  color: white;                    
  font-size: 13px;
  font-weight: 600;
  padding: 6px 8px;
  min-width: 80px;
  max-width: 150px;
  border-radius: 8px 8px 0 0;
  caret-color: white;         

  &::placeholder {
    color: rgba(255, 255, 255, 0.6);
  }

  // Selección de texto
  &::selection {
    background: rgba(255, 255, 255, 0.3);
    color: white;
  }
}
// Punto de cambios sin guardar
.tab-modified-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #ff9900;
  margin-left: 5px;
  vertical-align: middle;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0%   { opacity: 1; }
  50%  { opacity: 0.4; }
  100% { opacity: 1; }
}

.devices-panel {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 80px);  
}

.devices-list {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 8px;

  // Scrollbar estilizado
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #dee2e6;
    border-radius: 4px;

    &:hover {
      background: #adb5bd;
    }
  }
}

.nav-item[draggable="true"] {
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
}

.tab-dragging {
  opacity: 0.4;
}

.tab-drag-over {
  .nav-link {
    border-left: 3px solid #6c757d;
  }
}

.tab-name {
  display: inline-block;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.manual-toast {
  position: fixed;
  bottom: 24px;
  right: 24px;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: white;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  z-index: 9999;
  max-width: 320px;

  &--success { background: #28a745; }
  &--error   { background: #dc3545; }
  &--warning { background: #ff9900; }
}

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.toast-fade-enter,
.toast-fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

// ─── Skeleton viewport ────────────────────────────────────────────────────────
.skeleton-tabs {
  display: flex;
  gap: 4px;
  padding: 16px 16px 0 16px;
  background: #f2f2f2;
  border-radius: 4px 4px 0 0;
}

.skeleton-tab {
  width: 80px;
  height: 32px;
  border-radius: 8px 8px 0 0;
  background: #dee2e6;
  animation: shimmer 1.5s infinite;
  background: linear-gradient(90deg, #dee2e6 0%, #e9ecef 50%, #dee2e6 100%);
  background-size: 200% 100%;

  &--add {
    width: 110px;
    opacity: 0.5;
  }
}

.skeleton-viewport {
  position: relative;
  width: 100%;
  height: 60vh;
  background: #e9ecef;
  border-radius: 5px;
  overflow: hidden;
  margin-top: 15px;
  margin-bottom: 15px;
  border: 1px solid #dee2e6;
}

.skeleton-shimmer {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    rgba(255,255,255,0)   0%,
    rgba(255,255,255,0.5) 50%,
    rgba(255,255,255,0)   100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-device {
  position: absolute;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #dee2e6;
  animation: shimmer 1.5s infinite;
  background: linear-gradient(90deg, #dee2e6 0%, #e9ecef 50%, #dee2e6 100%);
  background-size: 200% 100%;

  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 6px;
    border-radius: 3px;
    background: #dee2e6;
  }
}

.skeleton-btn {
  position: absolute;
  right: 8px;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background: linear-gradient(90deg, #dee2e6 0%, #e9ecef 50%, #dee2e6 100%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;

  &--top { top: 8px; }
  &--mid { top: 48px; }
}

.skeleton-center-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  opacity: 0.25;
  z-index: 2;
}

.skeleton-center-icon {
  color: #495057;
}

.skeleton-center-spinner {
  width: 2rem;
  height: 2rem;
  color: #495057;
}

.text-toolbar {
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 6px 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.15);
  font-size: 12px;
  white-space: nowrap;

  &__group {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &__label {
    font-size: 11px;
    color: #6c757d;
    margin: 0;
  }

  &__color {
    width: 28px;
    height: 24px;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 1px;
    cursor: pointer;
  }

  &__number {
    width: 52px;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 2px 4px;
    font-size: 12px;
    text-align: center;
  }

  &__close {
    background: none;
    border: none;
    color: #6c757d;
    cursor: pointer;
    font-size: 12px;
    padding: 0 2px;
    line-height: 1;

    &:hover { color: #dc3545; }
  }
}

</style>